import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { Store } from '@ngrx/store';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationActions } from '../../store/navigation/actions/application.actions';
import { selectJWTToken } from '../../store/navigation/selectors/application.selectors';

@Injectable({ providedIn: 'root' })
export class JwtIncerceptor implements HttpInterceptor {
    private store = inject(Store);
    private nomWebServicesJson = inject(NomWebServicesJson);

    readonly token = this.store.selectSignal(selectJWTToken);

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        try {
            return next.handle(this.addAuthHeader(request)).pipe(
                map(r => {
                    if (r instanceof HttpResponse) {
                        this.handleResponse(r);
                    }
                    return r;
                })
            );
        } catch (e) {
            console.warn(e);
        }
    }

    private addAuthHeader(request: HttpRequest<unknown>): HttpRequest<unknown> {
        try {
            const { url } = request;
            const { method } = request;
            if (!url.endsWith('/api/IsAlive') && method !== 'JSONP') {
                const jwtToken = this.token();
                const isNonEnpsReq = url.includes('enpscloud.com') || url.includes('usviking.com') || url.includes('api.openai.com');
                if (jwtToken && !isNonEnpsReq) {
                    return request.clone({
                        setHeaders: {
                            Authorization: jwtToken,
                        },
                    });
                }
            }
            return request;
        } catch (e) {
            console.warn(e);
        }
    }

    private handleResponse(r: HttpResponse<any>) {
        // const isDiscoverReq = r.url.includes('enpscloud.com') || r.url.includes('usviking.com');
        // if (!isDiscoverReq) {
        try {
            let jwtToken = r.headers.get('Authorization');
            if (jwtToken) {
                if (jwtToken.trim().toLowerCase() === 'bearer') {
                    jwtToken = '';
                }
                this.store.dispatch(ApplicationActions.setJWTToken({ jwtToken: jwtToken }));
            }
            // }
            const newNomTokenId = r.headers.get('X-ENPS-TOKEN');
            if (newNomTokenId && newNomTokenId !== this.nomWebServicesJson.nomTokenId) {
                this.nomWebServicesJson.nomTokenId = newNomTokenId;
                localStorage.setItem('SessionNomTokenId', this.nomWebServicesJson.nomTokenId);
            }
            if (
                r.status >= 200 &&
                r.status < 300 &&
                !(r.url.endsWith('/api/IsAlive') || r.url.includes('/api/SSOSettings') || r.url.includes('/api/SSOConfigSetings') || r.url.includes('config.json'))
            ) {
                this.nomWebServicesJson.noSession = false;
            }
            const version = r.headers.get('jsonversion');
            if (version && version !== environment.pst_version && !environment.production) {
                // TODO: UNCOMMENT AFTER MODAL REWORK
                // const ref = this.modalService.openAlert('New Version', "A newer version is now available. Please click 'OK' to upgrade. You will need to login again.", '')
                // ref.result.then(() => {
                //     Util.clearLocalStorage();
                //     window.location.reload();
                // })
            }
        } catch (e) {
            console.warn(e);
        }
    }
}
